<script setup lang="ts">
import BottomBarComponent from '@/components/shared/BottomBarComponent.vue'
</script>

<template>
  <div>
    <router-view />
    <footer class="shell-footer">
      <div class="footer-content">
        <BottomBarComponent />
      </div>
    </footer>
  </div>
</template>

<style lang="scss" scoped>
.shell-footer {
  @include shell-footer-base;
  background-color: var(--purple50);
  border-top: 2px solid var(--white);
}

.footer-content {
  display: flex;
  max-width: var(--large-screen-width);
  margin: 0 auto;
  width: var(--width-100);
  flex-direction: column;
}
</style>
